<!-- @format -->
<!-- noinspection -->
<!-- @ts-nocheck -->
<!-- tslint:disable -->
<template>
  <span
      :aria-hidden="!!title"
      :aria-label="title"
      :class="`h-${normalizedSize} w-${normalizedSize} block flagicons-icon flag-de-icon`"
      :title="title"
      role="img"
      v-bind="$attrs"
      @click="$emit('click', $event)">
    <svg
        id="flag-icons-de"
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg">
      <path
          d="M0 341.3h512V512H0z"
          fill="#fc0" />
      <path
          d="M0 0h512v170.7H0z"
          fill="#000001" />
      <path
          d="M0 170.7h512v170.6H0z"
          fill="red" />
    </svg>
  </span>
</template>

<script>
  export default {
    name: 'flag-de',
    emits: ['click'],
    props: {
      title: {
        type: String
      },
      size: {
        type: [Number, String],
        default: 4
      }
    },
    computed: {
      normalizedSize() {
        return Number(this.size)
      }
    }
  }
</script>
